import { render } from "./ImageButton.vue?vue&type=template&id=0d16bfea&scoped=true"
import script from "./ImageButton.vue?vue&type=script&lang=js"
export * from "./ImageButton.vue?vue&type=script&lang=js"

import "./ImageButton.vue?vue&type=style&index=0&id=0d16bfea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d16bfea"

export default script